import AppDispatcher from '../dispatcher/AppDispatcher'
import assign from 'object-assign'
import { EventEmitter } from 'events'
import * as DonationConstants from '../utility/constants'

const CHANGE_EVENT = 'change';

let _alldata = {}; // collection of donation data

/**
 * @param {string} text The content donation
 */
function create(field, value) {

	_alldata[field] = value;
}

var DonationStore = assign({}, EventEmitter.prototype, {
	emitChange: function() {
		this.emit(CHANGE_EVENT);
	},

	getAllData: function() {
		return _alldata;
	},

	getDonationAmount: function() {
		return _alldata.amount;
	},

	getDonationSymbol: function() {
		return _alldata.symbol;
	},

	getDonationCode: function() {
		return _alldata.code;
	},

	getDonationNote: function() {
		return _alldata.note;
	},

	getConfirmation: function() {
		return _alldata.confirmation;
	},

	getCurrentPage: function() {
		return _alldata.currentPage;
	},

	getServerErros: function() {
		return _alldata.serverErrors;
	},

	getSignUpError: function() {
		return _alldata.signUpError;
	},

	getFundingOptions: function() {
		return _alldata.fundingOptions;
	},

	getEmail: function() {
		return _alldata.email;
	},

	getBillingAddress: function() {
		return _alldata.billingAddress;
	},


	dispatcherIndex: AppDispatcher.register(function(payload) {
		var action = payload.action;
		var amount, note, symbol, code, country, confirmation, currentPage, serverErrors, signUpError, fundingOptions, email, billingAddress;

		switch (action.actionType) {

			case DonationConstants.CHANGE_AMOUNT:
				amount = action.item.amount.trim();
				if (amount !== '') {
					create('amount', amount);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_SYMBOL:
				symbol = action.item.symbol.trim();
				if (symbol !== '') {
					create('symbol', symbol);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_CODE:
				code = action.item.code.trim();
				if (code !== '') {
					create('code', code);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_NOTE:
				note = action.item.note.trim();
				if (note !== '') {
					create('note', note);
					DonationStore.emitChange();
				} else {
					create('note', '');
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_COUNTRY:
				country = action.item.country.trim();
				if (country !== '') {
					create('country', country);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_CONFIRMATION:
				confirmation = action.item.confirmation;
				if (confirmation !== '') {
					create('confirmation', confirmation);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_CURRENT_PAGE:
				currentPage = action.item.currentPage;
				if (currentPage !== '') {
					create('currentPage', currentPage);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_SERVER_ERRORS:
				serverErrors = action.item.serverErrors;
				if (serverErrors !== '') {
					create('serverErrors', serverErrors);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_SIGN_UP_ERROR:
				signUpError = action.item.signUpError;
				if (signUpError !== '') {
					create('signUpError', signUpError);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.FUNDING_OPTIONS:
				fundingOptions = action.item.fundingOptions;
				if (fundingOptions !== '') {
					create('fundingOptions', fundingOptions);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.EMAIL:
				email = action.item.email;
				if (email !== '') {
					create('email', email);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.BILLING_ADDRESS:
				billingAddress = action.item.billingAddress;
				if (billingAddress !== '') {
					create('billingAddress', billingAddress);
					DonationStore.emitChange();
				}
				break;

			default:
				break;
		}

		return true; // No errors. Needed by promise in Dispatcher.
	})
});

AppDispatcher.register((payload) => {
	return true;
});

module.exports = DonationStore;



// WEBPACK FOOTER //
// ./stores/AppStore.js